import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from 'contentful';

export interface TypeHeaderMenuItemFields {
  pageTitle?: EntryFieldTypes.Symbol;
  pageLink?: EntryFieldTypes.Symbol;
  chipText?: EntryFieldTypes.Symbol;
  subtext?: EntryFieldTypes.Symbol;
}

export type TypeHeaderMenuItemSkeleton = EntrySkeletonType<
  TypeHeaderMenuItemFields,
  'headerMenuItem'
>;
export type TypeHeaderMenuItem<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeHeaderMenuItemSkeleton, Modifiers, Locales>;

export function isTypeHeaderMenuItem<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeHeaderMenuItem<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'headerMenuItem';
}

export type TypeHeaderMenuItemWithoutLinkResolutionResponse =
  TypeHeaderMenuItem<'WITHOUT_LINK_RESOLUTION'>;
export type TypeHeaderMenuItemWithoutUnresolvableLinksResponse =
  TypeHeaderMenuItem<'WITHOUT_UNRESOLVABLE_LINKS'>;
export type TypeHeaderMenuItemWithAllLocalesResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeHeaderMenuItem<'WITH_ALL_LOCALES', Locales>;
export type TypeHeaderMenuItemWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeHeaderMenuItem<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>;
export type TypeHeaderMenuItemWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeHeaderMenuItem<
  'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES',
  Locales
>;
